<template>
  <div>
    <el-card class="justify-center flex" v-if="!tag">
      <div style="max-width: 28rem;">
        <div style="text-align: left">
          <span style="color: #000000; font-size: 16px;">商家功能还在公测，目前商家入驻页面目前仅对VIP用户邀请开放且门槛较高，如您愿意进一步了解，请升级VIP然后查看本页面。</span>
        </div>
        <div style="padding: 20px">
          <router-link to="/upgrade" style="color: #f39" class="navbar-nav">
            <el-button size="small"><span style="font-size: 14px ">立即升级</span></el-button>
          </router-link>
        </div>
        <div style="text-align: left">
          <span style="color: #ff3399; font-size: 13px">我们当前商家入驻门槛比较高，且商家入驻功能并不是免费服务，我们并不能保证你升级VIP之后，一定可以达成入驻合作，请不要单纯因为入驻商家而去升级VIP，我们后期会逐步向更多用户公开商家入驻页面。</span>
        </div>
        </div>
    </el-card>
    <el-card v-if="tag" :body-style="{padding: '16px',textAlign: 'left'}">
      <div class="G-title">
        <span>商家入驻</span>
      </div>
      <div v-if="tag">
      <ol style="padding-inline-start: 15px;">
        <li>
          <strong>收费标准：</strong>
          <ul>
            商家入驻，不是免费服务，请联系我们获取报价。
          </ul>
        </li>
        <li>
          <strong>我们接受以下商户的商家：</strong>
          <ul>
            <li>各种具备固定经营场所的商务会所、KTV、夜总会；</li>
            <li>各种具备固定经营场所桑拿、按摩店；</li>
            <li>各种具备固定经营场所工作室；</li>
            <li>各种信誉良好的单一城市工作室。</li>
          </ul>
        </li>
        <li>
          <strong>我们不接受以下类型的商家：</strong>
          <ul>
            <li>不接受任何全国范围经营的商家；</li>
            <li>不接受任何办卡类以及引导办卡类的商户；</li>
            <li>不接所谓的全国空降类的合作；</li>
            <li>不接受任何单一楼凤作为商家入驻，楼凤请自行发帖；</li>
            <li>不接受任何存在欺诈行为的商户，以及价位和服务不对等的商家；</li>
          </ul>
        </li>
        <li>
          <strong>商家服务：</strong>
          <ul>
            <li>提供服务期限内商家频道的展示；</li>
            <li>在指定的城市信息流里展示；</li>
            <li>附送指定城市的发帖条数；</li>
          </ul>
        </li>
        <li>
          <strong>特别条款：</strong>
          <ul>
            <li>我们保留拒绝部分商家入驻的权利；</li>
            <li>如果商家入驻后出现办卡等欺诈行为，收到用户举报，我们将会立即下架，且费用不退；</li>
            <li>部分信誉存疑的商家初次入驻，我们可能需要对方提供保证金；</li>
          </ul>
        </li>
        <li>
          <strong>联系我们：</strong>
          <ul>
            <li>邮件：fengloukefu@gmail.com</li>
            <li>请在联系的时候，请详细介绍你的商家情况以及业务情况，任何没有详细介绍的商家合作信息，我们都不会回复； 我们没有任何QQ和微信，更不会通过微信和QQ主动联系你，请勿上当受骗，如有疑虑请跟我们的官方邮件核实； 我们将会在邮件里，
            筛选部分具备合作条件的商家去联系，如48小时没有回复证明不符合我们的合作标准； 我们不处理任何发帖审核的业务，我们也不接任何发帖的合作，楼凤和狼友请自行发帖；
            </li>
          </ul>
        </li>
      </ol>
    </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'merchant_join',
  data () {
    return {
      tag: true
    }
  }
}
</script>

<style scoped>
.justify-center {
  justify-content: center;
}
.flex {
  display: flex;
}
ul{
  padding-inline-start: 15px;
}
li {
  line-height: 1.5rem;
  font-size: 14px;
}
.G-title {
  font-weight: bold;
  border-bottom: 1px solid #f2f2f2 !important;
  padding-bottom: 10px;
  justify-content: space-between !important;
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/merchant_join.vue